import { render, staticRenderFns } from "./Contactdetails.vue?vue&type=template&id=dd4675c6&scoped=true&"
import script from "./Contactdetails.vue?vue&type=script&lang=js&"
export * from "./Contactdetails.vue?vue&type=script&lang=js&"
import style0 from "./Contactdetails.vue?vue&type=style&index=0&id=dd4675c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4675c6",
  null
  
)

export default component.exports